import Phaser from 'phaser';
import { COLORS } from '../constants/colors';

export const GRENADE_RADIUS = 6;

export class Grenade extends Phaser.GameObjects.Arc {
  private elapsed = 0;

  constructor(
    scene: Phaser.Scene,
    private readonly startX: number,
    private readonly startY: number,
    private readonly totalDistanceX: number,
    private readonly flightDurationMs: number,
    private readonly arcHeight: number,
    public readonly explosionRadius: number,
  ) {
    super(scene, startX, startY, GRENADE_RADIUS, 0, 360, false, COLORS.midGray);
    scene.add.existing(this);
  }

  // Возвращает true когда граната достигла цели (нужно взрывать).
  tick(deltaMs: number): boolean {
    this.elapsed += deltaMs;
    const t = Math.min(1, this.elapsed / this.flightDurationMs);
    this.x = this.startX + this.totalDistanceX * t;
    this.y = this.startY - this.arcHeight * Math.sin(Math.PI * t);
    return t >= 1;
  }
}
